// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bfVU","type":"styles_type__1oW23","choices":"styles_choices__3EFvh"};